<template>
    <div class="home-group">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <!--清除浮动-->
        <div style="clear: both"></div>
        <!--产品引导-->
        <section class="home-product">
            <div class="home-product-item1">
                <div class="home-product-img">
                    <router-link  class="font_small" :to="{path:'/product/mogos',query:{id:1}}">
                        <img src="../../assets/home/new_home/mogos_banner_card.png">
                        <img class="home_icon" src="../../assets/home/new_home/free_en@2x.png" v-if="this.Homelang == 'en' ">
                        <img class="home_icon" src="../../assets/home/new_home/free_sc@2x.png" v-else >
                    </router-link>
                </div>
                <div class="home-product-item1-1">
                    <div class="home_kownMore">
                        <div class="home_kownMore_content">
                            <router-link  class="font_small" :to="{path:'/product/mogos',query:{id:1}}">
                                <h1 class="font_big">
                                        {{$t('home_mogos')}}
                                </h1>
                            </router-link>
                            <div class="font_margin">
                                <p class="font_mid">{{$t('home_mogos_content')}}</p>
                                <p class="font_mid"><span style="text-decoration:line-through;color: red;"><span style="color: #1f2d3d">{{$t('home_mogos_originalprice')}}:$22</span></span></p>
                            </div>
                            <button class="font_small" style="width: 150px;height: 40px;">
                                <router-link  class="font_small" :to="{path:'/product/mogos',query:{id:1}}">
                                    {{$t('home_mogos_get')}}
                                </router-link>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--清除浮动-->
        <div style="clear: both"></div>
        <div class="home-product2">
            <div class="home-product-item2">
                <div class="home-product-item2-1">
                    <div class="home_kownMore">
                        <div class="home_kownMore_content">
                            <router-link class="font_small" :to="{path:'/product/s1',query:{id:3}}">
                                <h1 class="font_big">
                                    {{$t('home_mogos1')}}
                                </h1>
                            </router-link>
                            <div class="font_margin">
                                <p class="font_mid" style="margin-top: 10px;">{{$t('home_mogos1_content')}}</p>
                            </div>
                            <a class="font_small">
                                <router-link class="font_small" :to="{path:'/product/s1',query:{id:3}}">
                                    {{$t('Services_mainpage_remain_to_be_solved')}} <Icon type="arrow-right-c"></Icon>
                                </router-link>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="home-product-item2-2">
                    <div class="home_kownMore">
                        <div class="home_kownMore_content">
                            <router-link class="font_small" :to="{name:'iVoice'}">
                                <h1 class="font_big">
                                    {{$t('home_ivoice')}}
                                </h1>
                            </router-link>
                            <div class="font_margin">
                                <p class="font_mid" style="margin-top: 10px;">{{$t('home_ivoice_content')}}</p>
                                <p class="font_mid" style="margin-bottom: 10px;">{{$t('home_ivoice_content1')}}</p>
                            </div>
                            <router-link class="font_small" :to="{name:'iVoice'}">
                                <a class="font_small">{{$t('Services_mainpage_remain_to_be_solved')}} <Icon type="arrow-right-c"></Icon></a>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--清除浮动-->
        <div style="clear: both"></div>
        <!--最新资讯-->
        <div class="home_information">
            <div class="home_information_group"  v-for="(item,index) in meida" :key="index">
                <h1>{{$t('footer_media')}}</h1>
                <div class="home_information_img">
                    <img :src="item.img" >
                </div>
                <div class="home_information_content">
                    <h1 class="font_big" @click="more(item.cms_id)">
                        {{item.title}}
                    </h1>
                    <p class="font_small" style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;" v-html="item.content"></p>
                    <a class="font_small" @click="more(item.cms_id)">
                        {{$t('Services_mainpage_remain_to_be_solved')}} <Icon type="arrow-right-c"></Icon>
                    </a>
                </div>
            </div>
        </div>
        <!--清除浮动-->
        <div style="clear: both"></div>

        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>
<script>
    import scroll from  '../../assets/js/jquery.superscrollorama'
    import tweenmax from '../../assets/js/TweenMax.min'
    import navbar from '../Common/Navbar.vue'
    import modal from '../Common/Modal.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                isTransparent: true,
                selected: 'A',
                options: [
                    { text: '亚洲', value: 'A' },
                    { text: '欧洲', value: 'B' },
                    { text: '美国', value: 'C' },
                    { text: '澳大利亚',value: 'D'}
                ],
                meida:[]
            }
        },
        components: {
            navbar, modal
        },
        mounted () {
            //获取咨询
            this.Getmedia ()

            //获取语言包
            this.Homelang()
        },
        methods:{
            goTo () {
                this.$router.push({
                    path: '/product/mogos',
                    query: {
                        id: 1,
                        country:this.selected
                    }
                })
            },
            Getmedia () {
                // 获取咨询
                const module = 'index.php/Cms/index'
                let data = {}
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        console.log(response.data)
                        this.meida = response.data.data

                    }.bind(this))
            },
            // 查看更多
            more (id) {
                this.$router.push({
                    name: 'ConsultationDetails',
                    query:  {
                        cms_id: id
                    }
                })
            },
            // 判断语言包
            Homelang () {
                this.lang = this.$i18n.locale
                if (this.lang == 'en-US') {
                    this.Homelang ='en'
                }else{
                    this.Homelang ='sc'
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/_home.scss";

    /*
      athor:刘志豪 vt@ifreegroup.com;
      date:2017/10/18
    */
</style>



// WEBPACK FOOTER //
// Home.vue?227fb283